export const formatAmount = (amount: number) => {
  if (!Number.isFinite(amount)) {
    return '0';
  }
  return new Intl.NumberFormat('ja-JP').format(amount);
};
